import { createContext, useContext, useEffect, useState } from "react";

const PerformanceContext = createContext({ lowData: false, reducedEffects: false });
const readPreferences = () => {
  const connection = navigator.connection;
  const lowData = Boolean(connection?.saveData || /^(slow-2g|2g|3g)$/.test(connection?.effectiveType));
  const reducedEffects = lowData || window.matchMedia("(prefers-reduced-motion: reduce), (pointer: coarse), (max-width: 767px)").matches;
  return { lowData, reducedEffects };
};

export const PerformanceProvider = ({ children }) => {
  const [preferences, setPreferences] = useState(readPreferences);
  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce), (pointer: coarse), (max-width: 767px)");
    const update = () => setPreferences(readPreferences());
    const visibility = () => { document.documentElement.dataset.pageHidden = String(document.hidden); };
    navigator.connection?.addEventListener?.("change", update);
    media.addEventListener("change", update);
    document.addEventListener("visibilitychange", visibility);
    visibility();
    return () => {
      navigator.connection?.removeEventListener?.("change", update);
      media.removeEventListener("change", update);
      document.removeEventListener("visibilitychange", visibility);
    };
  }, []);
  useEffect(() => {
    document.documentElement.dataset.reducedEffects = String(preferences.reducedEffects);
    document.documentElement.dataset.lowData = String(preferences.lowData);
  }, [preferences]);
  return <PerformanceContext.Provider value={preferences}>{children}</PerformanceContext.Provider>;
};

export const usePerformance = () => useContext(PerformanceContext);